import { Component } from '@angular/core';
import { EqBaseComponent } from '../eq-base/eq-base.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';

const Material = [
  MatFormFieldModule,
  MatRippleModule,
  MatIconModule,
  MatCheckboxModule,
];
@Component({
  selector: 'eq-checkbox',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ...Material
  ],
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss',
})
export class CheckboxComponent extends EqBaseComponent{}
